'use client';

import { useEffect } from 'react';
import CustomImage from './Image';

const ImageModal = ({ isOpen, onClose, imageUrl, alt }) => {
  // Close modal when pressing Escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden'; // Prevent scrolling when modal is open
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 backdrop-blur-sm"
      onClick={onClose}
    >
      {/* Small hint text at the bottom */}
      <div className="fixed bottom-4 left-1/2 -translate-x-1/2 text-white/60 text-sm pointer-events-none">
        Click anywhere to close
      </div>
      <div className="relative w-full h-full max-w-6xl max-h-[90vh] p-4">
        <button 
          onClick={onClose}
          className="absolute top-2 right-2 bg-black/50 hover:bg-black/70 text-white hover:text-gray-300 p-2 rounded-full text-xl z-10 transition-colors"
          aria-label="Close"
        >
          ✕
        </button>
        <div className="relative w-full h-full">
          <CustomImage
            src={imageUrl}
            alt={alt}
            fill
            className="object-contain cursor-pointer"
            priority
            sizes="(max-width: 768px) 95vw, 80vw"
          />
        </div>
      </div>
    </div>
  );
};

export default ImageModal;
